export default "__VITE_ASSET__DhnPkpEv__"